export const popupWindowParams = (width: number, height: number) => {
  const popupWidth = width ? width : window.innerWidth * 0.7
  const popupHeight = height ? height : window.innerHeight * 0.7
  // Opens the new window at the center of the current window.
  const top = (window.top.outerHeight / 2) + window.top.screenY - (popupHeight / 2)
  const left = (window.top.outerWidth/ 2) + window.top.screenX - (popupWidth / 2)
  return `toolbar=0, status=0, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`
}
